import api from 'api';
import storage from "storage";

class parametrosService {

  salvar(dados) {
    var token = storage.get("user", "token");
    return new Promise((resolve, reject) => {
      dados.token = token;
      const url = dados.id ? '/configuracoes/' + dados.id : '/configuracoes';
      let promise = null;

      if (dados.id) promise = api.put(url, dados)
      else promise = api.post(url, dados)

      promise.then((result) => {
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  listar() {
    var token = storage.get("user", "token");
    return new Promise((resolve, reject) => {
      api.get('/configuracoes', {
        params: {
          token: token
        }
      }).then((result) => {
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  detalhes(id) {
    var token = storage.get("user", "token");
    return new Promise((resolve, reject) => {
      api.get('/configuracoes/' + id, {
        params: {
          token: token
        }
      }).then((result) => {
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  delete(id) {
    var token = storage.get("user", "token");
    return new Promise((resolve, reject) => {
      api.delete('/configuracoes/' + id, {
        params: {
          token: token
        }
      }).then((result) => {
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

  // retorna em formato json os parâmetros especificados na array
  params(labId) {
    var token = storage.get("user", "token");
    return new Promise((resolve, reject) => {
      api.post('/configuracoes/busca/' + labId, {
        params: [],
        token: token
      }).then((result) => {
        resolve(result.data);
      }).catch((error) => {
        reject(error);
      });
    });
  }

}
export default new parametrosService();